app.directive('scrollContainer', ["$timeout", "$parse", function($timeout, $parse) {

	return {

		restrict: 'A',
		scope: {},
		link: function(scope, element, attrs) {
			scope.containerElement = element;
		},
		controller: ["$scope", function($scope) {

			this.ScrollTop = function(childElemTop, childElemBottom) {
				var container = $scope.containerElement;
				var containerBottom = container.offset().top + container.height();
				var containerTop = container.offset().top;
				if(childElemBottom > containerBottom) {
					container[0].scrollTop += childElemBottom - containerBottom;
				}
				else if(childElemTop < containerTop) {
					container[0].scrollTop += childElemTop - containerTop;
				}
			};
		}]
	};

}]).directive('scrollContainerItem', ["$timeout", "$parse", function($timeout, $parse) {

	return {
		restrict: 'A',
		require: '^scrollContainer',
		link: function(scope, element, attrs, scrollContainerCtrl) {
			var expr = $parse(attrs.triggerContainerScroll);
			scope.$watch(expr, function(newVal) {
				if(newVal) {
					$timeout(function() {
						var myTop = element.offset().top;
						var myBottom = element.offset().top + element[0].offsetHeight;
						scrollContainerCtrl.ScrollTop(myTop, myBottom);
					});
				}
			});
		},
		controller: ["$scope", function($scope) {


		}]
	};
}]);

